import {
  API_ERROR,
  QUALITY,
  QUALITY_LIST_SUCCESSFUL,
 QUALITY_ADD,
  QUALITY_ADD_SUCCESSFUL,
  QUALITY_EDIT,
  QUALITY_EDIT_SUCCESSFUL,
  QUALITY_DELETE,
  QUALITY_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS,
} from "./actionTypes";

export const getQuality = (params) => {
   return {
    type: QUALITY,
    payload: params,
  };
};

export const qualityListSuccessful = ({ response, params }) => {
  return {
    type: QUALITY_LIST_SUCCESSFUL,
    payload: { response, params },
  };
};

export const qualityAdd = (quality, history) => {
   return {
    type: QUALITY_ADD,
    payload: { quality, history },
  };
};

export const qualityAddSuccessful = (response) => {
   return {
    type: QUALITY_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const qualityEdit = (data) => {
  return {
    type: QUALITY_EDIT,
    payload: data,
  };
};

export const qualityEditSuccessful = (response) => {
    return {
      type: QUALITY_EDIT_SUCCESSFUL,
      payload: response,
    };
  };

export const qualityDelete = (qualityId, history) => {
  return {
    type: QUALITY_DELETE,
    payload: { qualityId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: QUALITY_SETROWDATA,
    payload: data,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
